<ng-container *transloco="let t">
  <main class="reactivate">
    @if (!loading) {
      <section class="reactivate__header">
        <img src="/assets/images/logo.png" alt="" class="reactivate__logo" />
      </section>
      <app-reactivate-payment
        [subscriptionDebt]="subscriptionDebt"
        [error]="error"
      ></app-reactivate-payment>
    } @else {
      <div class="ui-loader">
        <pxw-icon icon="loading" [spin]="true" size="lg"></pxw-icon>
      </div>
    }
  </main>
</ng-container>

